import { TreeListItem } from './TreeListWidget';

/**
 * Keep matching branches and expand them without mutating the original tree.
 */
export const filterNavigationItems = (items: TreeListItem[], query: string): TreeListItem[] => {
  const term = query.trim().toLocaleLowerCase();
  if (!term) return items;
  const expand = (item: TreeListItem): TreeListItem => ({
    ...item,
    defaultExpanded: true,
    children: item.children?.map(expand)
  });
  return items.flatMap((item) => {
    if (item.label.toLocaleLowerCase().includes(term)) return [expand(item)];
    const children = filterNavigationItems(item.children ?? [], query);
    return children.length ? [{ ...item, children, defaultExpanded: true }] : [];
  });
};
